import { SxProps } from "@mui/material"

export const sxItalicText: SxProps = {
  fontFamily: "Montserrat-Italic",
  fontSize: "var(--font-size-small)"
}

export const sxItalicTextXs: SxProps = {
  fontFamily: "Montserrat-Italic",
  fontSize: "var(--font-size-xs)",
  fontWeight: "bold"
}

export const sxBoldText: SxProps = {
  fontFamily: "Montserrat-Bold",
  fontSize: "var(--font-size-small)"
}

export const sxBoldTextXs: SxProps = {
  fontFamily: "Montserrat-Bold",
  fontSize: "var(--font-size-xs)",
  fontWeight: "bold"
}

export const sxDivider: SxProps = { 
  background: 'rgba(28, 55, 117, 0.25)', backgroundColor: 'rgba(28, 55, 117, 0.25)' 
}

